module.exports = __webpack_public_path__ + "static/media/multivariatetesting.92380bc5.jpeg";